import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { getFolderFileById } from "../../utils/treeData/folderEditorUtils";
import { useTreeContext } from "../../context/TreeDataContext";
import { useConnectorsContext } from "../../context/ConnectorsContext";
import EmailConnector from "./EmailConnector/EmailConnector";

const ConnectorRenderer = () => {
  const { connectorsExplorerData } = useTreeContext();
  const { selectedConnector, setSelectedConnector } = useConnectorsContext();
  const { connectorId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (connectorId) {
      const file = getFolderFileById(connectorsExplorerData, connectorId);
      if (file) {
        setSelectedConnector({
          id: file.id,
          name: file.name,
          type: file.parentData
        });
      } else {
        setSelectedConnector({
          id: "",
          name: "",
          type: ""
        });
        navigate("../");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connectorId]);

  if (!selectedConnector || !selectedConnector.id) {
    return null;
  }
  if (selectedConnector.type === "email_connectors") {
    return <EmailConnector />;
  } else {
    return null;
  }
};
export default ConnectorRenderer;
